import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import { businessArea, pdfArea, pricingArea, processingArea } from "~/router"
import { useStore } from "~/store"
import { isRoute } from "~/utils"

export const useArea = () => {
    const route = useRoute()

    const isArea = (area: string) =>
        isRoute(route, `/${area}`)

    const currentArea = computed(() => route.path.split('/')[1])

    const isPdfPage = computed(() => isArea(pdfArea))

    const isProcessingPage = computed(() => isArea(processingArea))

    const isPricingPage = computed(() => isArea(pricingArea))

    const isBusinessPage = computed(() => isArea(businessArea))

    return {
        currentArea,
        isPdfPage,
        isPricingPage,
        isBusinessPage,
        isProcessingPage
    }
}

export const useApi = () => {
    const route = useRoute()

    const path = computed(() => route.meta?.apiUrl as string | undefined ?? '')

    const entityId = computed(() => route.params['id'])

    const entityPath = computed(() => `${path.value}/${entityId.value}`)

    return {
        path,
        entityId,
        entityPath
    }
}

export const useProfile = () => {
    const store = useStore()

    const profile = computed(() => store.profile)

    const isTelemed = computed(() => !!profile.value?.isTelemed)

    const isDirectMarketing = computed(() => !!profile.value?.isDirectMarketing)

    const isVitalityAgent = computed(() => !!profile.value?.isVitalityAgent)

    const isInternalAgent = computed(() => isVitalityAgent.value || isDirectMarketing.value)

    const isCommercialUnderwriter = computed(() => !!profile.value?.isCommercialUnderwriter)

    return {
        isTelemed,
        isVitalityAgent,
        isDirectMarketing,
        isInternalAgent,
        isCommercialUnderwriter
    }
}